var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _vm.proprietario.pessoa.pessoaFisica &&
      _vm.proprietario.pessoa.pessoaFisica.cpf
        ? _c(
            "div",
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Nome completo:",
                          content: _vm.proprietario.pessoa.pessoaFisica.nome
                        }
                      }),
                      _vm._v(" "),
                      _c("app-display", {
                        attrs: {
                          label: "CPF:",
                          content: _vm.proprietario.pessoa.pessoaFisica.cpf
                        }
                      }),
                      _vm._v(" "),
                      _c("app-display", {
                        attrs: {
                          label: "RG:",
                          content: _vm.proprietario.pessoa.pessoaFisica.rg
                        }
                      }),
                      _vm._v(" "),
                      _c("app-display", {
                        attrs: {
                          label: "Sexo:",
                          content: _vm.formataSexo(
                            _vm.proprietario.pessoa.pessoaFisica.sexo
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("app-display", {
                        attrs: {
                          label: "Data de nascimento:",
                          content: _vm.formataDataNascimento(
                            _vm.proprietario.pessoa.pessoaFisica.dataNascimento
                          )
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Município/UF de naturalidade:",
                          content: _vm.proprietario.pessoa.pessoaFisica
                            .naturalidade
                            ? _vm.proprietario.pessoa.pessoaFisica.naturalidade
                                .nome +
                              "/" +
                              _vm.proprietario.pessoa.pessoaFisica.naturalidade
                                .codigoEstado
                            : ""
                        }
                      }),
                      _vm._v(" "),
                      _c("app-display", {
                        attrs: {
                          label: "E-mail(s):",
                          content: _vm.proprietario.pessoa.emails.length
                            ? _vm.proprietario.pessoa.emails
                                .map(function(e) {
                                  return e.dado
                                })
                                .join(", ")
                            : ""
                        }
                      }),
                      _vm._v(" "),
                      _c("app-display", {
                        attrs: {
                          label: "Telefone(s):",
                          content: _vm.proprietario.pessoa.telefones.length
                            ? _vm.proprietario.pessoa.telefones
                                .map(function(t) {
                                  return t.numero
                                })
                                .join(", ")
                            : ""
                        }
                      }),
                      _vm._v(" "),
                      _c("app-display", {
                        attrs: {
                          label: "Estado civil:",
                          content: _vm.formataEstadoCivil(
                            _vm.proprietario.pessoa.pessoaFisica.estadoCivil
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("app-display", {
                        attrs: {
                          label: "Renda familiar:",
                          content: _vm.formataRendaFamiliar(
                            _vm.proprietario.pessoa.pessoaFisica.rendaFamiliar
                          )
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.proprietario.conjuge &&
              _vm.proprietario.conjuge.pessoaFisica.cpf &&
              (_vm.proprietario.pessoa.pessoaFisica.estadoCivil === "CASADO" ||
                _vm.proprietario.pessoa.pessoaFisica.estadoCivil ===
                  "UNIAO_ESTAVEL")
                ? _c(
                    "div",
                    { staticClass: "mt-2" },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("app-display", {
                                attrs: {
                                  label: "Regime de bens:",
                                  content: _vm.formataRegimeDeBens(
                                    _vm.proprietario.conjuge.pessoaFisica
                                      .regimeBens
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _c("app-display", {
                                attrs: {
                                  label: "Nome completo:",
                                  content:
                                    _vm.proprietario.conjuge.pessoaFisica.nome
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("app-display", {
                                attrs: {
                                  label: "CPF:",
                                  content:
                                    _vm.proprietario.conjuge.pessoaFisica.cpf
                                }
                              }),
                              _vm._v(" "),
                              _c("app-display", {
                                attrs: {
                                  label: "Sexo:",
                                  content: _vm.formataSexo(
                                    _vm.proprietario.conjuge.pessoaFisica.sexo
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _c("app-display", {
                                attrs: {
                                  label: "Município/UF de naturalidade:",
                                  content: _vm.proprietario.conjuge.pessoaFisica
                                    .naturalidade
                                    ? _vm.proprietario.conjuge.pessoaFisica
                                        .naturalidade.nome +
                                      "/" +
                                      _vm.proprietario.conjuge.pessoaFisica
                                        .naturalidade.codigoEstado
                                    : ""
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _c(
            "div",
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Razão social:",
                          content:
                            _vm.proprietario.pessoa.pessoaJuridica.razaoSocial
                        }
                      }),
                      _vm._v(" "),
                      _c("app-display", {
                        attrs: {
                          label: "Nome fantasia:",
                          content:
                            _vm.proprietario.pessoa.pessoaJuridica.nomeFantasia
                        }
                      }),
                      _vm._v(" "),
                      _c("app-display", {
                        attrs: {
                          label: "CNPJ:",
                          content: _vm.proprietario.pessoa.pessoaJuridica.cnpj
                        }
                      }),
                      _vm._v(" "),
                      _c("app-display", {
                        attrs: {
                          label: "Inscrição estadual:",
                          content:
                            _vm.proprietario.pessoa.pessoaJuridica
                              .inscricaoEstadual
                        }
                      }),
                      _vm._v(" "),
                      _c("app-display", {
                        attrs: {
                          label: "Código CNAE (subclasse):",
                          content:
                            _vm.proprietario.pessoa.pessoaJuridica.cnae.codigo
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Nome da atividade conforme CNAE:",
                          content:
                            _vm.proprietario.pessoa.pessoaJuridica.cnae
                              .nomeAtividade
                        }
                      }),
                      _vm._v(" "),
                      _c("app-display", {
                        attrs: {
                          label: "Ramo de atuação:",
                          content:
                            _vm.proprietario.pessoa.pessoaJuridica.ramoAtuacao
                        }
                      }),
                      _vm._v(" "),
                      _c("app-display", {
                        attrs: {
                          label: "E-mail(s):",
                          content: _vm.proprietario.pessoa.emails.length
                            ? _vm.proprietario.pessoa.emails
                                .map(function(e) {
                                  return e.dado
                                })
                                .join(", ")
                            : null
                        }
                      }),
                      _vm._v(" "),
                      _c("app-display", {
                        attrs: {
                          label: "Telefone(s):",
                          content: _vm.proprietario.pessoa.telefones.length
                            ? _vm.proprietario.pessoa.telefones
                                .map(function(t) {
                                  return t.numero
                                })
                                .join(", ")
                            : null
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "CEP:",
                  content: _vm.proprietario.pessoa.enderecoCorrespondencia.cep
                }
              }),
              _vm._v(" "),
              _c("app-display", {
                attrs: {
                  label: "Logradouro:",
                  content:
                    _vm.proprietario.pessoa.enderecoCorrespondencia.logradouro
                }
              }),
              _vm._v(" "),
              _c("app-display", {
                attrs: {
                  label: "Número:",
                  content:
                    _vm.proprietario.pessoa.enderecoCorrespondencia.numero
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Complemento:",
                  content:
                    _vm.proprietario.pessoa.enderecoCorrespondencia
                      .complemento ||
                    _vm.proprietario.pessoa.enderecoCorrespondencia
                      .comunidadeLocalidade
                }
              }),
              _vm._v(" "),
              _c("app-display", {
                attrs: {
                  label: "Bairro:",
                  content:
                    _vm.proprietario.pessoa.enderecoCorrespondencia.bairro
                }
              }),
              _vm._v(" "),
              _c("app-display", {
                attrs: {
                  label: "Município/UF:",
                  content: _vm.proprietario.pessoa.enderecoCorrespondencia
                    .municipio
                    ? _vm.formataMunicipioUF(
                        _vm.proprietario.pessoa.enderecoCorrespondencia
                          .municipio
                      )
                    : ""
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "title-proprietario" }, [
        _vm._v("Dados do proprietário")
      ]),
      _vm._v(" "),
      _c("hr")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "title-proprietario" }, [
        _vm._v("Dados do cônjuge")
      ]),
      _vm._v(" "),
      _c("hr")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-2" }, [
      _c("span", { staticClass: "title-proprietario" }, [
        _vm._v("Endereço de correspondência")
      ]),
      _vm._v(" "),
      _c("hr")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b25f04fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b25f04fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Proprietario/Proprietario.vue
// module id = null
// module chunks = 